export default {
    getUgCards: (state) => state.ugCards,
    getUgPagination: (state) => state.ugPagination,
    getUgTooltip: (state) => state.ugTooltip,
    getGmTable: (state) => state.gmTable,
    getGmPagination: (state) => state.gmPagination,
}